import { cn } from '@insta-club/utilities';
import { IconProps } from './icons-props';

function AttachmentIcon({ className, width = 30, height = 30 }: IconProps) {
    return (
        <svg
            className={cn('text-gray-700', className)}
            width={width}
            height={height}
            viewBox='0 0 30 30'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M15.2497 21.725C14.3747 21.725 13.4872 21.3875 12.8247 20.725C12.1747 20.075 11.8122 19.2125 11.8122 18.3C11.8122 17.3875 12.1747 16.5125 12.8247 15.875L14.5872 14.1125C14.9497 13.75 15.5497 13.75 15.9122 14.1125C16.2747 14.475 16.2747 15.075 15.9122 15.4375L14.1497 17.2C13.8497 17.5 13.6872 17.8875 13.6872 18.3C13.6872 18.7125 13.8497 19.1125 14.1497 19.4C14.7622 20.0125 15.7497 20.0125 16.3622 19.4L19.1372 16.625C20.7247 15.0375 20.7247 12.4625 19.1372 10.875C17.5497 9.28748 14.9747 9.28748 13.3872 10.875L10.3622 13.9C9.72467 14.5375 9.37469 15.375 9.37469 16.2625C9.37469 17.15 9.72467 18 10.3622 18.625C10.7247 18.9875 10.7247 19.5875 10.3622 19.95C9.99967 20.3125 9.39967 20.3125 9.03717 19.95C8.04967 18.9625 7.51221 17.65 7.51221 16.25C7.51221 14.85 8.04967 13.5375 9.03717 12.55L12.0622 9.52496C14.3747 7.21246 18.1497 7.21246 20.4622 9.52496C22.7747 11.8375 22.7747 15.6125 20.4622 17.925L17.6872 20.7C17.0122 21.3875 16.1372 21.725 15.2497 21.725Z'
                fill='currentColor'
            />
            <path
                d='M18.75 28.4375H11.25C4.4625 28.4375 1.5625 25.5375 1.5625 18.75V11.25C1.5625 4.4625 4.4625 1.5625 11.25 1.5625H18.75C25.5375 1.5625 28.4375 4.4625 28.4375 11.25V18.75C28.4375 25.5375 25.5375 28.4375 18.75 28.4375ZM11.25 3.4375C5.4875 3.4375 3.4375 5.4875 3.4375 11.25V18.75C3.4375 24.5125 5.4875 26.5625 11.25 26.5625H18.75C24.5125 26.5625 26.5625 24.5125 26.5625 18.75V11.25C26.5625 5.4875 24.5125 3.4375 18.75 3.4375H11.25Z'
                fill='currentColor'
            />
        </svg>
    );
}

export default AttachmentIcon;

